import { Processor } from '../../../shared/types/processors.type';
import { TagLabel } from './tag.type';

export interface ServerWave {
  onset: number;
  offset: number;
  type: ServerWaveType;
  tags: TagLabel[];
}

export type ServerWaveType = 'P' | 'QRS' | 'T' | 'INV';

export type BeatWaveType = 'P' | 'QRS' | 'T';

export const INVALID_WAVE_TYPES = [
  'artifact',
  'calibration',
  'microvolted',
  'no_signal',
  'noise',
  'p_level_noise',
  'pt_level_noise',
  'qrs_level_noise',
  'uncertain',
] as const;

export type InvalidWaveType = typeof INVALID_WAVE_TYPES[number];

export interface Wave extends Omit<ServerWave, 'type'> {
  type: BeatWaveType | InvalidWaveType;
  id: string; // the back has no id for the waves so we use a local one
  background: boolean;
  link?: WaveLink;
}

export type WaveId = Wave['id'];

export type WaveType = Wave['type'];

export interface WaveLink {
  waveId: WaveId;
  type: 'onset' | 'offset';
}

export type WaveTypeMapping<T = string> = Record<WaveType, T>;

export type WaveProcessor = Processor<Wave>;
